// components/AppShell.jsx
import { CompareHost } from './compare/CompareHost';
import {FilterHost} from "./FilterHost";
import {ToastHost} from "./ToastHost";

export const AppShell = () => (
    <>
        <FilterHost />
        <ToastHost />
        <CompareHost />
    </>
);